<template>
    <div class="seckill-container">
        <div class="container-box">
            <div class="banner">
                <div class="title">{{ bannerTitle }}</div>
                <div class="desc">{{ limitCount }}</div>
            </div>
            <!-- <div class="top-tips" v-if="content.isReachedPageScore">
                您还可以选择{{ limitCount - countStatus - count }}件礼品
            </div> -->
            <div class="inner-container">
                <div class="list">
                    <List
                        :list="awardList"
                        :limitCount="limitCount - countStatus"
                        @currentSelected="currentSelected"
                        @orderIdDialog="orderIdDialog"
                        :content="content"
                        @imageAlbum="imageAlbum"
                    />
                </div>
            </div>
            <!-- <div class="bottom-container">
                <div
                    class="bottom-tips"
                    v-if="!content.isReachedPageScore && !content.isAllReceived"
                >
                    升至{{ content.requiredScore }}活力值可领
                </div>
                <div class="line" v-if="limitCount - countStatus !== 0"></div>
                <div class="bottom" v-if="limitCount - countStatus !== 0">
                    <div class="left-txt">已选购{{ count }}件商品</div>
                    <div class="right-btn" @click="awardBtnClick()" v-if="isShowBtn()">
                        {{ awardBtnTxt() }}
                    </div>
                </div>
            </div> -->
        </div>
        <Dialog1
            :show="showDialog"
            title="前往首页申请借款，成交后即可激活成长权益"
            lefttxt="再看看"
            righttxt="去首页"
            @giveupBtn="giveupBtn"
            @continueBtn="continueBtn"
        />
        <Dialog2
            :show="showUpdataDialog"
            title="做任务可以增加活力值哦！"
            lefttxt="再看看"
            righttxt="去做任务"
            @giveupBtn="giveupTask"
            @continueBtn="doSomeTask"
        />
        <TitleSingleBtnDialog
            :show="showSingleBtnTitleDialog"
            title="等待即送"
            content="领取成功后，商品将在7天内寄出。请耐心等待"
            righttxt="知道了"
            @continueBtn="closeSingleDialog"
        />
        <TitleDialog
            :show="showTitleDialog"
            title="已寄送"
            :content="titleContent"
            lefttxt="复制单号"
            righttxt="关闭"
            @giveupBtn="copyOrderId()"
            @continueBtn="closeTitleDialog()"
        />
        <Album
            :show="showAlbum"
            :imgIndex="currentIndex"
            :imageList="imageList"
            :desc="currentDesc"
            @close="closeAlbum"
        />
    </div>
</template>

<script>
import homemixin from '@common/js/mixin';

export default {
    name: 'upgradepage',
    components: {
        Dialog1: () => import('../../componets/birthday/homeDialog'),
        Dialog2: () => import('../../componets/birthday/homeDialog'),
        List: () => import('../../componets/upgrade/list'),
        TitleDialog: () => import('../../componets/birthday/homeTitleDialog'),
        TitleSingleBtnDialog: () => import('../../componets/birthday/homeSingleBtnTitleDialog'),
        Album: () => import('../../componets/birthday/album')
    },
    mixins: [homemixin],
    data() {
        return {
            titleContent: '',
            showAlbum: false,
            currentIndex: 0,
            imageList: [],
            bannerTitle: '',
            bannerDesc: '',
            awardList: [],
            currentDesc: '',
            countStatus: 0,
            showTitleDialog: false,
            showSingleBtnTitleDialog: false,
            count: 0,
            limitCount: 0,
            paymoneytxt: '',
            level: 'V1',
            currentSelectList: [],
            showDialog: false,
            showUpdataDialog: false,
            content: {},
            titleBar: {
                fullScreen: 2,
                visible: 1,
                leftView: [
                    {
                        action: 'back',
                        color: '#000000',
                        icon: 'ppdwebui://resource/drawable/nav_back',
                        callback: this.goClose
                    }
                ],
                titleView: {
                    text: '实物礼包',
                    color: '#000000'
                },
                rightView: [
                    {
                        action: 'custom',
                        text: '领取记录',
                        callback: () => {
                            this.$router.push('/records/entity');
                        }
                    }
                ]
            }
        };
    },
    mounted() {
        // this.isOldCustomer = localStorage.getItem('KUserisOldCustomer');
        // this.currentScore = localStorage.getItem('KUserTotalScore');
    },
    async created() {
        if (window.PPDWebUI.os.inApp) {
            window.PPDWebUI.CommonService.setNavigation(this.titleBar);
        }
        this.packId = this.$route.query.packId;
        await this.getGiftPackInfo();
    },
    methods: {
        // goBacktoHome() {
        //     this.$router.push('/');
        // },
        closeSingleDialog() {
            this.showSingleBtnTitleDialog = false;
        },
        imageAlbum(item) {
            this.showAlbum = true;
            this.currentIndex = 0;
            this.imageList = item.bigImg;
            this.currentDesc = item.detailDesc;
        },
        closeAlbum() {
            this.showAlbum = false;
        },

        itemBtnDesc(item) {
            if (this.currentSelectList.indexOf(item.awardKey) !== -1) {
                return '取消添加';
            } else {
                if (item.awardStatus === 20) {
                    return '查看物流';
                }
                return '添加至清单';
            }
        },
        orderIdDialog(item) {
            console.log(item);

            if (item.businessNum) {
                this.showTitleDialog = true;
                this.orderId = item.businessNum;
                this.itemName = item.awardName;
                this.titleContent = `商品已寄出，物流单号:${this.orderId}`;
                this.POINT('h5_clk', {
                    tgt_event_id: 'h5_ACT_button',
                    tgt_name: 'h5_ACT_升级礼包物流弹窗',
                    page: 'super-升级礼包物流弹窗',
                    param1: `${this.content.score}`,
                    param2: `${this.content.requiredScore}`,
                    param3: `知道了`,
                    param4: `${item.awardName}`
                });
            } else {
                this.showSingleBtnTitleDialog = true;
                this.POINT('h5_clk', {
                    tgt_event_id: 'h5_ACT_button',
                    tgt_name: 'h5_ACT_升级礼包物流弹窗',
                    page: 'super-升级礼包物流弹窗',
                    param1: `${this.content.score}`,
                    param2: `${this.content.requiredScore}`,
                    param3: `未寄出`,
                    param4: `${item.awardName}`
                });
            }
        },
        copyOrderId() {
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_button',
                tgt_name: 'h5_ACT_升级礼包物流弹窗',
                page: 'super-升级礼包物流弹窗',

                param1: `${this.content.score}`,
                param2: `${this.content.requiredScore}`,
                param3: `复制单号`,
                param4: `${this.itemName}`
            });
            this.showTitleDialog = false;
            this.$copyText(this.orderId).then(
                e => {
                    this.$toast({
                        message: '复制成功',
                        duration: 2000
                    });
                },
                e => {
                    this.$toast({
                        message: '复制失败',
                        duration: 2000
                    });
                }
            );
        },
        closeTitleDialog() {
            this.showTitleDialog = false;
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_button',
                tgt_name: 'h5_ACT_升级礼包物流弹窗',
                page: 'super-升级礼包物流弹窗',
                param1: `${this.content.score}`,
                param2: `${this.content.requiredScore}`,
                param3: `关闭`,
                param4: `${this.itemName}`
            });
        },
        giveupBtn() {
            this.showDialog = false;
        },
        continueBtn() {
            this.goHome();
        },

        currentSelected(selectList) {
            this.currentSelectList = selectList;
            this.count = selectList.length;
            this.awardBtnClick();
        },
        awardBtnTxt() {
            if (!this.content.isReachedPageScore) {
                if (!this.content.isOldCustomer) {
                    return '去激活';
                } else {
                    return '增加活力值';
                }
            } else {
                return '确认领取';
            }
        },

        isShowBtn() {
            if (!this.content.isReachedPageScore && this.content.isAllReceived) {
                return false;
            } else {
                return true;
            }
        },
        awardBtnClick() {
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_button',
                tgt_name: 'h5_ACT_升级礼包',
                page: 'super-升级礼包',
                param1: `${this.content.score}`,
                param2: `${this.content.requiredScore}`,
                param3: `${this.awardBtnTxt()}`,
                param4: `${this.currentSelectList.length}`
            });
            if (!this.content.isReachedPageScore) {
                if (!this.content.isOldCustomer) {
                    this.showDialog = true;
                } else {
                    // localStorage.setItem('updata', 'true');
                    // this.$router.replace({
                    //     path: '/'
                    // });
                    // this.goClose();
                    this.showUpdataDialog = true;
                }
            } else {
                this.awardGift();
            }
        },
        doSomeTask() {
            localStorage.setItem('updata', 'true');
            this.goClose();
        },
        giveupTask() {
            this.showUpdataDialog = false;
        },
        awardGift() {
            if (this.currentSelectList.length <= 0) {
                this.$toast({
                    message: '请选择商品',
                    duration: 2000
                });
                return;
            }

            window.sessionStorage.setItem('score', this.content.score);
            window.sessionStorage.setItem('requiredScore', this.content.requiredScore);
            window.sessionStorage.setItem('awardBtnTxt', this.awardBtnTxt());

            this.$router.push({
                path: '/address',
                query: {
                    list: this.currentSelectList
                }
            });
        },
        skipOuter() {
            if (this.content.isOldCustomer) {
                this.$router.replace({
                    path: '/'
                });
            } else {
                this.showDialog = true;
            }
        },

        async getGiftPackInfo() {
            const { Result, Content } = await this.$http.getGiftPackInfo({
                packId: this.packId
            });
            if (Result === 200) {
                this.awardList = Content.awardList;
                this.limitCount = Content.count;
                this.content = Content;
                this.bannerTitle = `${this.content.requiredScore}活力值专享`;
                this.bannerDesc = `超值好礼 任选${this.limitCount}项`;
                this.countStatus = Content.count - Content.availableQuantity;
                console.log(this.limitCount, this.countStatus);
                // let count = 0;
                for (let i = 0; i < this.awardList.length; i++) {
                    let award = this.awardList[i];
                    // if (award.awardStatus === 20) {
                    //     count++;
                    // }
                    this.POINT('h5_element_imp', {
                        tgt_event_id: 'h5_ACT_imp',
                        tgt_name: 'h5_ACT_升级礼包详情',
                        page: 'super-升级礼包详情',
                        param1: `${this.content.score}`,
                        param2: `${this.content.requiredScore}`,
                        param3: `${award.awardStatus === 20 ? '查看物流' : '添加至清单'}`,
                        param4: award.awardName
                    });
                }
                this.POINT('h5_element_imp', {
                    tgt_event_id: 'h5_ACT_imp',
                    tgt_name: 'h5_ACT_升级礼包',
                    page: 'super-升级礼包',
                    param1: `${this.content.score}`,
                    param2: `${this.content.requiredScore}`,
                    param3: `${this.awardBtnTxt()}`
                });
            }
        }
    }
};
</script>

<style lang="less" scoped>
@import '~@common/style/common.less';

.seckill-container {
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;
    background-color: white;

    .container-box {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        .banner {
            z-index: 1111;
            .backgroundImage(375px, 100px, '~@assets/img/banner_physicalgifts@2x.png');

            .title {
                position: absolute;
                top: 62px;
                left: 36px;
                white-space: nowrap;
                min-width: 85px;
                height: 14px;
                font-size: 12px;
                font-family: fzlt_bold;
                font-weight: normal;
                color: #762020;
                line-height: 14px;
            }

            .desc {
                position: absolute;
                left: 152px;
                top: 24px;
                width: 12px;
                height: 29px;
                font-size: 24px;
                font-family: fzlt_bold;
                font-weight: bold;
                color: #ff7f35;
                line-height: 29px;
            }
        }

        .top-tips {
            .f-12();
            z-index: 1111;
            line-height: 15px;
            left: 0;
            right: 0;
            margin: auto;
            margin-top: 12px;
            margin-bottom: 5px;
            text-align: center;
            color: #292738;
            background: white;
        }

        .inner-container {
            z-index: 1;
            width: 100%;
            height: 100%;
            overflow: hidden;
            overflow-y: scroll;

            .list {
                width: 375px;
                background-color: rgba(255, 255, 255, 1);
                border-radius: 6px;
                margin: auto;
                margin-bottom: 62px;
                margin-top: -5px;
            }
        }

        .bottom-container {
            position: fixed;
            bottom: 0;
            background: white;
            padding-bottom: constant(safe-area-inset-bottom);
            padding-bottom: env(safe-area-inset-bottom);
            width: 100%;

            .bottom-tips {
                width: 100%;
                height: 26px;

                color: #904e30;

                z-index: 111;
                text-align: center;
                line-height: 26px;
                .f-10-bold();
                background-color: #fdf6de;
            }

            .line {
                width: 100%;
                height: 1px;

                z-index: 11;
                background-color: #e4e4e4;
                transform: scaleY(0.5);
            }

            .bottom {
                z-index: 11;
                background: white;
                width: 100%;
                height: 44px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                z-index: 11;
                padding-left: 20px;
                padding-right: 8px;

                .left-txt {
                    color: #292738;
                    .f-12-bold();
                }

                .right-btn {
                    width: 102px;
                    height: 32px;
                    text-align: center;
                    color: #904e30;
                    .f-14-bold();
                    line-height: 32px;
                    background: rgba(216, 216, 216, 1)
                        linear-gradient(
                            90deg,
                            rgba(244, 213, 131, 1) 0%,
                            rgba(240, 188, 83, 1) 100%
                        );
                    border-radius: 17px;
                }
            }
        }
    }
}
</style>
